import logger from './logger';

let hasLoggedSuppressedFailure = false;
let isGuardInstalled = false;

const FAILED_FETCH_MESSAGES = ['failed to fetch', 'load failed'];

const normalizeReason = (reason) => {
  if (typeof reason === 'string') {
    return reason.toLowerCase();
  }

  if (!reason || typeof reason !== 'object') {
    return '';
  }

  return [reason.name, reason.message, reason.stack]
    .filter((part) => typeof part === 'string' && part.trim().length > 0)
    .join(' ')
    .toLowerCase();
};

export const isIoniconsFetchFailure = (reason) => {
  const text = normalizeReason(reason);
  if (!text) {
    return false;
  }

  const hasFetchFailure = FAILED_FETCH_MESSAGES.some((message) => text.includes(message));
  if (!hasFetchFailure) {
    return false;
  }

  return text.includes('ionicons')
    || text.includes('/ionicons/')
    || text.includes('loadicon')
    || text.includes('s-ion-icon');
};

export const suppressIoniconsFetchFailure = (event) => {
  if (!event || !isIoniconsFetchFailure(event.reason)) {
    return false;
  }

  event.preventDefault?.();

  if (!hasLoggedSuppressedFailure) {
    logger.warn('Ionicons asset fetch failed; continuing without the affected icon.', event.reason);
    hasLoggedSuppressedFailure = true;
  }

  return true;
};

export const installIoniconsFetchFailureGuard = (target = window) => {
  if (!target || typeof target.addEventListener !== 'function' || isGuardInstalled) {
    return () => {};
  }

  const handleUnhandledRejection = (event) => {
    suppressIoniconsFetchFailure(event);
  };

  target.addEventListener('unhandledrejection', handleUnhandledRejection);
  isGuardInstalled = true;

  return () => {
    if (typeof target.removeEventListener === 'function') {
      target.removeEventListener('unhandledrejection', handleUnhandledRejection);
    }
    isGuardInstalled = false;
  };
};

export const resetIoniconsFetchGuardForTests = () => {
  hasLoggedSuppressedFailure = false;
  isGuardInstalled = false;
};